import React, { createContext, useEffect, useState } from 'react';
import { readStoredPharmacyPOS, usePharmacy } from './PharmacyProvider';
import { readPharmacyPrivilege } from '../utils/pharmacyPrivilege';

const PrivilegeContext = createContext();

export const PrivilegeContextProvider = ({ children }) => {
  const pharmacy = usePharmacy();
  const pharmacyPOS = pharmacy?.pharmacyPOS ?? null;

  const [privileges, setPrivileges] = useState(() =>
    readPharmacyPrivilege(readStoredPharmacyPOS())
  );

  useEffect(() => {
    setPrivileges(readPharmacyPrivilege(pharmacyPOS));
  }, [pharmacyPOS]);

  // This function can be used to update privileges when the login API is called
  const setUserPrivileges = (privilegesData) => {
    setPrivileges(privilegesData);
  };

  return (
    <PrivilegeContext.Provider value={{ privileges, setUserPrivileges }}>
      {children}
    </PrivilegeContext.Provider>
  );
};

export default PrivilegeContext;
